export const CHAT_HISTORY_WINDOW = 12;

export const CHAT_FEATURE_REQUIRED_MESSAGE =
  'ИИ-ассистент доступен только на платном тарифе. Свяжитесь с нами, чтобы подключить его.';
